import { removeCookies } from 'cookies-next'
import { UserAPI } from '../apis/UserAPI'
import {
    getJWT,
    getWooCookiesFromServer,
    getWooSessionKeys,
    isValidWooCookies,
    WP_SESSION_KEY,
} from './api'
import { getErrorMessage, log, wooCommerceSessionKey } from './utils'

export const handleRenew = async ({ req, res }, callback) => {
    try {
        let refreshToken = await UserAPI.tryRefresh(getJWT(req))
        const { data } = await UserAPI.checklogin(refreshToken.data.data.jwt)
        data.requestURL = req.query.requestURL
        data.renewed = true
        return callback(data)
    } catch (e) {
        return res.status(401).json({ message: e.response.data.data.message })
    }
}

export const handleRemovalOfWooCookies = (req, res) => {
    const wooCookies = getWooSessionKeys(req)
    let session_key

    if (isValidWooCookies(wooCookies)) {
        const sessionKeyCookie = wooCookies?.['Cookie']
            .split(';')
            .find((item) => item.includes(WP_SESSION_KEY))
        session_key = sessionKeyCookie?.split('=')[1].split('||')[0]

        if (!session_key.includes('t_')) {
            removeCookies(wooCommerceSessionKey, { req, res })
        }
    }
}

export const handleUserLogin = async (req) => {
    let { data } = await UserAPI.checklogin(getJWT(req))
    data.requestURL = req.query.requestURL
    data.body = req.body
    req.customer_id = data.data.user.ID

    return { req, data }
}

export const handleWooCookiesForCart = async (req) => {
    try {
        const { req: request } = await handleUserLogin(req)
        const wooSessionKeyValue = await getWooCookiesFromServer(
            request.customer_id,
            request.customer_id,
        )
        // log('request.customer_id', request.customer_id)
        // log('has set from here', wooSessionKeyValue)
        req.headers.cookie = `${[wooCommerceSessionKey]}=${wooSessionKeyValue}`
        req.headers.cookieValue = wooSessionKeyValue
        req.headers.hasSetCookie = true
        return req
    } catch (e) {
        log('error', getErrorMessage(e))
        return req
    }
}
